namespace $.$$ {
	export class $shm_hitalama_benchmarks_client_frame extends $.$shm_hitalama_benchmarks_client_frame {
		@ $mol_mem
		override dom_node_actual(){
			const node=super.dom_node_actual()
			this.client().bind(node as HTMLIFrameElement)
			return node
		}
	}
}
